document.addEventListener("DOMContentLoaded", function () {
  
  document.querySelector('[is="next-button"]').classList.add('drv-swiper-button-next-custom')
  const slides = document.querySelectorAll('five-videos-template--25917260824941__videos_UmTm3t .swiper-wrapper .swiper-slide');

  if (slides.length === 1) {
    const slide = slides[0];

    slide.style.width = "100%";
    slide.style.minHeight = "500px";

    // Якщо всередині є iframe – теж збільшимо
    const iframe = slide.querySelector('iframe');
    if (iframe) {
      iframe.style.width = "100%";
      iframe.style.minHeight = "500px";
    }
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const icon = `<img src="https://cdn.shopify.com/s/files/1/0961/2220/8621/files/bluecheck.svg?v=1764325036" 
                   style="width:16px; height:16px; display:inline-block; margin-right:6px;">`;

  const paragraphs = document.querySelectorAll('.prose p');

  paragraphs.forEach(p => {
    p.innerHTML = p.innerHTML.replace("✔️", icon);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('#shopify-section-template--25917260824941__media_with_text_Wdg7ef .prose');
  const iconUrl = "https://cdn.shopify.com/s/files/1/0961/2220/8621/files/bluecheck.svg?v=1764325036";

  if (container) {
    const paragraphs = container.querySelectorAll('p');

    paragraphs.forEach(p => {
      const img = document.createElement('img');
      img.src = iconUrl;
      img.style.width = "16px";
      img.style.height = "16px";
      img.style.display = "inline-block";
      img.style.marginRight = "6px";

      // Вставляємо іконку перед текстом
      p.prepend(img);
    });
  }
});




// Завантаження YouTube Iframe API асинхронно
let tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let players = {};

console.log('works');


function onYouTubeIframeAPIReady() {
  // Для кожного iframe з класом youtube-video створюємо плеєра
  document.querySelectorAll('.youtube-video').forEach((iframe, index) => {
    let player = new YT.Player(iframe, {
      events: {
        onReady: onPlayerReady
      }
    });
    players[iframe.id] = player;

    // Створюємо елементи контролів
    let container = iframe.parentElement;
    container.style.position = 'relative';

    let controls = document.createElement('div');
    controls.classList.add('video-controls');
    controls.style.position = 'absolute';
    controls.style.bottom = '10px';
    controls.style.left = '10px';
    controls.style.display = 'none';
    controls.style.zIndex = '10';

    // Кнопка Play/Pause
    let playPauseBtn = document.createElement('button');
    playPauseBtn.textContent = 'Play';
    playPauseBtn.style.marginRight = '5px';
    controls.appendChild(playPauseBtn);

    // Кнопка Mute/Unmute
    let muteBtn = document.createElement('button');
    muteBtn.textContent = 'Mute';
    controls.appendChild(muteBtn);

    container.appendChild(controls);

    // Показ контролів при hover
    container.addEventListener('mouseenter', () => {
      controls.style.display = 'block';
    });
    container.addEventListener('mouseleave', () => {
      controls.style.display = 'none';
    });

    // Логіка кнопок
    playPauseBtn.addEventListener('click', () => {
      let playerState = player.getPlayerState();
      // 1 - playing, 2 - paused
      if (playerState === YT.PlayerState.PLAYING) {
        player.pauseVideo();
        playPauseBtn.textContent = 'Play';
      } else {
        player.playVideo();
        playPauseBtn.textContent = 'Pause';
      }
    });

    muteBtn.addEventListener('click', () => {
      if (player.isMuted()) {
        player.unMute();
        muteBtn.textContent = 'Mute';
      } else {
        player.mute();
        muteBtn.textContent = 'Unmute';
      }
    });
  });
}

function onPlayerReady(event) {
  // Відео готове, наприклад, можна включити автозапуск або інші дії
}

